// src/redux/account/accountSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchAccount } from "./accountThunk";
import { buildPermissions } from "./buildPermissions ";
const accountSlice = createSlice({
  name: "account",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccount.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAccount.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchAccount.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default accountSlice.reducer;
